import { useState, useEffect, useContext } from 'react';
import { Language } from '../../../App';

const useWebinarButtonText = (value, user_id) => {
    const {lang} = useContext(Language)
  const [buttonText, setButtonText] = useState('');
   
  useEffect(() => {
    const userIsHost = value?.user?.id === user_id;
    const status = value?.status;
    const isReserve = value?.isReserve;

    if (userIsHost) {
      if (status === 0) {
        setButtonText(lang.not_start_yet);
      } else if (status === 2) {
        setButtonText(lang.webinar_ended);
      } else {
        setButtonText(lang.start_webinar);
      }
    } else {
      if (status === 0) {
        setButtonText(isReserve ? lang.unreserve : lang.reserve_seat);
      } else if (status === 1) {
        setButtonText(isReserve ? lang.join_webinar : lang.reserve_seat);
      } else if (status === 2) {
        setButtonText(lang.webinar_ended);
      }
    }
  }, [value, user_id,lang]);

  return buttonText;
};

export default useWebinarButtonText;
